import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { BaseText, SkeletonLoader } from '@warrenbrasil/nebraska-web';
import { Money } from '@/modules/common/components/MoneyV2';

import { NumberFormatted } from '@/modules/trade/types';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { getCurrencyTextColor } from '@/modules/common/helpers/currency';

interface Props {
  label: string;
  valueObject: NumberFormatted;
  shouldValueBeColored?: boolean;
  shouldHideValueWithMoneyToggle?: boolean;
  isLoading: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'VerticalListDisplay',
  props: {
    label: null,
    valueObject: null,
    shouldValueBeColored: { type: Boolean, default: false },
    shouldHideValueWithMoneyToggle: { type: Boolean },
    isLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { label: string, valueObject: NumberFormatted, shouldValueBeColored: boolean, shouldHideValueWithMoneyToggle?: boolean, isLoading: boolean };



const valueFormatted = computed(() => {
  return props.valueObject?.formatted || '-';
});

const valueColor = computed(() => {
  if (props.shouldValueBeColored && props.valueObject) {
    return getCurrencyTextColor(props.valueObject.value);
  }
  return NebraskaColors.elementPrimary;
});

const valueComponent = computed(() => {
  return props.shouldHideValueWithMoneyToggle ? Money : 'span';
});

return { __sfc: true,props, valueFormatted, valueColor, valueComponent, BaseText, SkeletonLoader, NebraskaColors }
}

})